/**
 * Safari の「サイト越えトラッキングを防ぐ」に対応するには Storage Access API で許可を得る必要がある。
 * @See https://webkit.org/blog/8124/introducing-storage-access-api/
 * @See https://developer.mozilla.org/ja/docs/Web/API/Document/requestStorageAccess
 */
(function($) {
    $.fn.embedAgreement = function (options) {

        // ストレージアクセス許可 API がないブラウザは何もしない
        // たとえば Chrome は許可/拒否を問い合わせないので requestStorageAccess を定義していない
        if (!document.hasStorageAccess || !document.requestStorageAccess) {
            return;
        }

        // Edge >= 113 の hasStorageAccess は実装が不完全で嘘情報を返すし、
        // requestStorageAccess は呼び出しだけで許可になって、ユーザー確認ダイアログを出さないしなので、
        // こんなクソブラウザはしばらく相手にしないことにする。
        // 「サードパーティの Cookie をブロックする」をあえて選んだ人が
        //  投稿エラーになるのは知ったこっちゃない。そんなの手動で許可サイトを設定してくださいで。
        if (isEdge113()) {
            return;
        }

        options = $.extend({
            notification: null,
            trigger: null
        }, options);

        const blockAndAskStorageAccess = (event) => {
            event.preventDefault();
            event.stopPropagation();
            document.requestStorageAccess().then(
                function () {
                    // 新たに許可された / いつの間にか許可が与えられていて無言で成功した
                    window.alert("ブラウザに許可が与えられました。zawazawa コメントを再読み込みします。");
                    window.location.reload();
                },
                function () {
                    // 拒否された
                    // 本当はクリックした位置にもっとリッチなのを出したいけど難しい
                    window.alert("ブラウザに許可がないため、zawazawa コメントの機能を利用できません。\n\n" +
                        "Safari / iOS の仕様: 過去に一度も zawazawa を直接利用したことがないと、無条件に不許可となることがあります。また、iOS プライベートブラウズモードでは常に不許可となります。");
                }
            );
        };

        const hookAllTargets = () => {
            this.find(options.notification).append(
                $('<span>').text("現在ブラウザに書き込み操作の許可が与えられていません。")
            ).append(
                $('<button>').text("許可する").on('click', blockAndAskStorageAccess)
            ).show();
            this.find(options.trigger).each(function () {
                this.addEventListener('click', blockAndAskStorageAccess, {
                    // キャプチャーフェーズで「許可/拒否」モーダルを出し、
                    // 本来の機能に行かないようにする!!
                    capture: true
                });
            });
        };

        let self = this;
        document.hasStorageAccess().then(function(hasAccess) {
            if (!hasAccess) {
                hookAllTargets();
            } else {
                self.find(options.notification).hide();
            }
        });

        // 最初次のコードを試したが、これでは常に静かに「拒否された」に到達してしまう。
        //
        // document.hasStorageAccess().then(function(hasAccess) {
        //     if (hasAccess) {
        //         // ストレージへのアクセスはすでに許可されています。
        //     } else {
        //         // ストレージへのアクセスはまだ許可されていません。
        //         // requestStorageAccess() を呼び出す必要があります。
        //         document.requestStorageAccess().then(
        //             function () {
        //                 // 許可された
        //             },
        //             function () {
        //                 // 拒否された
        //             }
        //         );
        //     }
        // });
        //
        // 検証した結果 hasStorageAccess() のコールバック内では requestStorageAccess() が静かに失敗する。
        // たぶん requestStorageAccess() はユーザーアクションイベント起点でないと駄目という制約があり、また
        // hasStorageAccess().then() つまり Promise のコールバックはその文脈でない、という実装になってる？
    };
})(jQuery);

function isEdge113() {
    if (!navigator.userAgentData) {
        return false;
    }
    for (const brand of navigator.userAgentData.brands) {
        if (brand.brand === 'Microsoft Edge' && parseInt(brand.version) >= 113) {
            return true
        }
    }
    return false
}
